<template>
    <div>
        <div class="border-divider"></div>
        <div class="cat-name-sidebar text-uppercase text-5F5 mt-3 mb-2" :class="{'d-none': hideCatName}">configuration</div>
        <div :class="{'mt-3': hideCatName}">
            <BLink class="button-sidebar"
               v-ripple
               :class="{'active': isActive(item.paths), 'button-sidebar-min': isSmallDesign}"
               @click="handleClick($event, item.paths)"
               :href="item.link"
               v-for="item in links"
               :key="item.link">
                <i class="mi-1-3x top-0" :class="item.icon"></i>
                <span :class="{'ml-1': !isSmallDesign}">{{item.title}}</span>
            </BLink>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import sidebarMixin from "@/mixins/sidebar/mixin";

export default {
    name: 'ConfigurationSidebar',
    computed: {
        ...mapGetters(['isSmallDesign', 'currentUserCan']),
        ...mapState({
            projectId: state => state.sidebar.projectId,
            path: state => state.sidebar.path,
            width: state => state.sidebar.width,
        }),
        links() {
            let links = [];
            if (this.currentUserCan('manage_workflow')) {
                links.push({'title': 'Workflow', 'icon': 'mi-low-priority', 'link': `/project/${this.projectId}/workflow`, paths: [`project/${this.projectId}/workflow`]});
            }
            if (this.currentUserCan('manage_template')) {
                links.push({'title': 'Templates', 'icon': 'mi-art-track', 'link': `/project/${this.projectId}/templates`, paths: [`project/${this.projectId}/templates`]});
            }
            if (this.currentUserCan('manage_categories')) {
                links.push({'title': 'Categories', 'icon': 'mi-content-copy', 'link': `/project/${this.projectId}/categories`, paths: [`project/${this.projectId}/categories`]});
            }

            return links;
        },
        hideCatName: vm => vm.width < 100
    },
    mixins: [sidebarMixin],
}
</script>
